import { useEffect, useState } from "react";
import './dashUser.css';
import { io } from 'socket.io-client';
import { urlServer } from '../../config.js';
import { appFirebase, messaging } from '../../firebase/credenciales.js';
import { getFirestore, collection, onSnapshot } from 'firebase/firestore';
import { doc, getDoc } from 'firebase/firestore';  // Importa Firestore desde Firebase SDK
import Swal from "sweetalert2";
import { getAuth } from 'firebase/auth';
// import { onMessage } from 'firebase/messaging';
import { onMessage } from "firebase/messaging";

import Header from "./header";
import Sidebar from './sidebar.jsx';
import Index from './main-content/index.jsx';
  import CompraNumeros from "./main-content/compraNumeros.jsx";
  import AnuncioSorteo from "./main-content/anuncioSorteo.jsx";
  import AnuncioGanador from "./main-content/AnuncioGanador.jsx";
  import SorteoExpress from "./main-content/SorteoExpress.jsx";
import CargaNequi from "./main-content/cargar.jsx";
import ActivateSeller from "./main-content/ActivateSeller.jsx";
// import SorteoBoard from "./main-content/sorteoBoard.jsx";
// import AnuncioGanador from "./main-content/ganador.jsx";
// import { useFetcher } from "react-router-dom";

const db = getFirestore(appFirebase); // Inicializa Firestore
const auth = getAuth(appFirebase);    // Inicializa Auth



const DashUser = () => {
    const [dataEmpresa,setDataEmpresa] = useState(null)
    const [dataUser, setDataUser] = useState(null)
    const [dataSorteos, setDataSorteos] = useState(null)
    const [board, setBoard] = useState('index')
    const [dataBoard, setDataBoard] = useState({})
    const [socket, setSocket] = useState(null);  // Estado inicial null para socket
    const [dataCargaNequi, setDataCargaNequi] = useState(null)
    const [dataUsers, setDataUsers] = useState(null)


    const empresa = async () => {
        try {
          const empresaRef = doc(db, 'empresa', 'empresa');
          const empresaDoc = await getDoc(empresaRef);
          if (empresaDoc.exists()) {
            const empresaData = empresaDoc.data();
            setDataEmpresa(empresaData);
          } else {
            console.error('No se encontró el documento de la empresa.');
          }
        } catch (error) {
          console.error('Error al obtener la empresa:', error);
        }
      };
      
      const sorteos = () => {
        const sorteosRef = collection(db, 'sorteos'); // Referencia a la colección 'sorteos'
        const unsubscribe = onSnapshot(sorteosRef, (snapshot) => {
          const sorteosData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })); // Mapea los documentos para extraer los datos
          setDataSorteos(sorteosData); // Actualizar el estado con los datos de los sorteos
        });
        return unsubscribe; // Devuelve la función de limpieza (unsubscribe)
      };
      const carga = ()=>{
        const cargaRef = collection(db, 'CargaNequi')
        const unsubscribe = onSnapshot(cargaRef, (snapshot) => {
          const cargaData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
          setDataCargaNequi(cargaData)
        })
        return unsubscribe
      }
      const users = ()=>{
        const usersRef = collection(db,'users')
        const unsubscribe = onSnapshot(usersRef, (snapshot) => {
          const usersData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
          setDataUsers(usersData)
        })
        return unsubscribe
      }
      
      const user = (socket) => {
        try {
          const currentUser = auth.currentUser;
          if (currentUser) {
            const userRef = doc(db, 'users', currentUser.uid);
            
            // Escuchar cambios en tiempo real con onSnapshot
            const unsubscribe = onSnapshot(userRef, (userDoc) => {
              if (userDoc.exists()) {
                const userData = userDoc.data();
                if(userData.init && userData.typeUser==='basic'){
                  Swal.fire({
                    title: '¿Estás listo para la Versión Beta?',
                    text: "Esta es una versión preliminar, podrías encontrar algunas funciones limitadas. Adicional te hemos obsequiado $1000 para que realices tu primera participácion",
                    icon: 'info',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    // cancelButtonColor: '#d33',
                    confirmButtonText: 'Sí, Gracias',
                    // cancelButtonText: 'Cancelar'
                    allowOutsideClick: false, // Evita que se cierre al hacer clic fuera del modal

                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Acción al aceptar
                      socket.emit('initYa',userData.data.uid)
                    }
                  });
                }else if (userData.init && userData.typeUser==='activo'){
                  Swal.fire({
                    title: 'Tu recarga se completo con exito',
                    text: `Hemos completado tu recarga, y por ser la primera vez que realizas este proceso, te hemos duplicado el valor, tu nuevo saldo es de: $${userData.saldo}`,
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    // cancelButtonColor: '#d33',
                    confirmButtonText: 'Gracias',
                    // cancelButtonText: 'Cancelar'
                    allowOutsideClick: false, // Evita que se cierre al hacer clic fuera del modal

                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Acción al aceptar
                      socket.emit('initYa',userData.data.uid)
                    }
                  });
                }
                setDataUser({
                  ...userData,
                  imgUser: currentUser.photoURL,
                  uid: currentUser.uid,
                });
              } else {
                console.error('No se encontró el documento del usuario.');
              }
            }, (error) => {
              console.error('Error al obtener el usuario:', error);
            });
      
            return unsubscribe; // Devuelve la función para desuscribirse del listener
      
          } else {
            console.error('No hay un usuario autenticado.');
          }
        } catch (error) {
          console.error('Error al obtener el usuario:', error);
        }
      };
      
      

useEffect(() => {
    navigator.serviceWorker.ready.then((swRegistration) => {
        // Registrar onMessage
        onMessage(messaging, (payload) => {
            console.log('Notificación en primer plano:', payload);

            // Mostrar notificación o modal
            // Swal.fire({
            //     title: payload.notification.title,
            //     text: payload.notification.body,
            //     confirmButtonText: 'Aceptar',
            // });
        });
    });
}, []);

    
      useEffect(() => {
        // Registrar el evento onMessage
      

      
        const newSocket = io(urlServer)
        setSocket(newSocket);
        // user(); // Llama a la función para obtener datos del usuario
        empresa(); // Llama a la función para obtener los datos de la empresa
        const unsubscribeSorteo = sorteos(); // Escucha cambios en la colección de sorteos
        const unsubscribeUser = user(newSocket)
        const unsubscribeCarga = carga()
        const unsubscribeUsers = users()
        return () => {
          unsubscribeUsers && unsubscribeUsers()
          unsubscribeCarga && unsubscribeCarga()
          unsubscribeUser && unsubscribeUser()
          unsubscribeSorteo && unsubscribeSorteo(); // Desuscribirse de los sorteos al desmontar el componente
          newSocket.disconnect(); // Desconecta el socket cuando se desmonte el componente
        };
        
      }, []);
    const activarVendedor= (data)=>{
      //console.log(data)
      socket.emit('activarVendedor',{data,uid:dataUser.uid})
    } 

    return (
        <div className="dashUser">
            {!!dataEmpresa && !!dataUser && (
                <>
                    <Header 
                        dataEmpresa={dataEmpresa} 
                        dataUser={dataUser} 
                    />
                </>
            )}
            <div className="main">
                <Sidebar 
                  board={setBoard} 
                  dataUser={dataUser}
                />
                <div className="main-content" style={{ backgroundImage: `url('./fondo.jpg')` }}>
                     {board === 'index' && (
                        <Index 
                          dataInfo={{
                            cambioBoard:setBoard,
                            cambioDataBoard:setDataBoard,
                            socket,
                            data:{
                              dataBoard,
                              dataUser,
                              dataSorteos,
                              dataEmpresa,
                            },
                          }}
                        />
                    )}
                    {board === 'compraNumeros' && (
                        <CompraNumeros
                            dataInfo={{
                              cambioBoard:setBoard,
                              cambioDataBoard:setDataBoard,
                              socket,
                              data:{
                                ...dataBoard,
                                dataUser,
                                dataSorteos,
                              },
                            }}
                        />
                    )}
                    {board === 'sorteoExpress' && (
                        <SorteoExpress
                            dataInfo={{
                              cambioBoard:setBoard,
                              cambioDataBoard:setDataBoard,
                              socket,
                              data:{
                                ...dataBoard,
                                dataUser,
                                dataSorteos,
                                dataUsers
                              },
                            }}
                        />
                    )}
                    {board === 'AnuncioSorteo' && (
                        <AnuncioSorteo
                            dataInfo={{
                              cambioBoard:setBoard,
                              cambioDataBoard:setDataBoard,
                              socket,
                              data:{
                                ...dataBoard,
                                dataUser,
                                dataSorteos,
                              },
                            }}
                        />
                    )}
                    {board === 'AnuncioGanador' && (
                        <AnuncioGanador
                          dataInfo={{
                            cambioBoard:setBoard,
                            cambioDataBoard:setDataBoard,
                            socket,
                            data:{
                              ...dataBoard,
                              dataUser,
                              dataSorteos,
                            },
                          }}
                        />
                    )}
                    {board === 'Cargar' && (
                        <CargaNequi 
                            dataEmpresa={dataEmpresa} 
                            dataUser={dataUser} 
                            socket={socket} 
                            dataCargaNequi={dataCargaNequi} 
                        />
                    )}
                    {board === 'ActivarVendedor' && (
                        <ActivateSeller 
                        usuario={dataUser}
                        onActivateSeller={activarVendedor}
                        />
                    )}

                    {/*
                    {board === 'SorteoBoard' && <SorteoBoard data={sorteoBoard} datainicio={inicio} numeroGanado={ganador} fechaSorteo={fechaSorteo}/>}
                    {board === 'AnuncioSorteo' && <AnuncioGanador numeroGanador={ganador}/>} */}
                </div>
            </div>

            {/* <div className="footer">footer</div> */}
        </div>
    );
};

export default DashUser;
